import React, { useState, useEffect } from 'react';
import {
  Row, Col, Spin, notification,
} from 'antd';
import {
  useNavigate, useLocation,
} from 'react-router-dom';
import Summary from '../summary/Summary';
import SuccessSolicitation from '../../../serviceComponents/successSolicitation/SuccessSolicitation';
import { getUserType } from '../../../../../utils/users';

const Flow = () => {
  const initialParameters = () => ({
    isSkippingSteps: false,
    serviceList: [],

    selectedService: {
      id: 0,
      idCode: '',
      name: '',
      description: '',
      types: [],
    },

    selectedType: {
      id: 0,
      idCode: '',
      name: '',
      subtypes: [],
    },

    selectedProperty: {
      id: '',
      name: '',

      location: {
        lat: null,
        lon: null,
      },

      registeredOn: '',
      matriculation: '',
    },

    selectedMatriculation: getUserType() === 'COOPERCITRUS' ? null : 'COOPERATIVE',

    selectedOwner: {
      id: '',
      name: '',
    },

    serviceTypeDynamicFields: [],
    serviceSubtypeDynamicFields: [],
    talhoesSelecionados: [],
  });

  const [currentPage, setCurrentPage] = useState(-1);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const locationObject = useLocation();
  const [serviceRequestParameters, setServiceRequestParameters] = useState(initialParameters());

  const removeSelectedField = (id) => {
    setServiceRequestParameters((previous) => {
      return ({
        ...previous,
        talhoesSelecionados: previous.talhoesSelecionados.filter((v) => v.id !== id),
      });
    });
  };

  useEffect(() => {
    setLoading(true);

    if (!locationObject.state?.serviceRequestParams) {
      notification.error({
        description: 'Houve um erro ao solicitar o serviço.',
      });

      setLoading(false);
      navigate('/service/new');

      return;
    }

    setServiceRequestParameters(locationObject.state?.serviceRequestParams);
    setCurrentPage(0);
    setLoading(false);
  }, []);

  const previousPage = (parameters) => {
    if (currentPage === 0) {
      navigate('/service/new', {
        state: {
          skipToPage: 3,
          serviceID: serviceRequestParameters.selectedService.id,
          matriculation: serviceRequestParameters.matriculation,
          allServiceParameters: serviceRequestParameters,
        },
      });
      return;
    }

    setServiceRequestParameters((previous) => {
      return ({
        ...previous,
        ...parameters,
      });
    });
    setCurrentPage((previous) => previous - 1);
  };

  const nextPage = (parameters) => {
    setServiceRequestParameters((previous) => {
      return ({
        ...previous,
        ...parameters,
      });
    });
    setCurrentPage((previous) => previous + 1);
  };

  return (
    <div
      className="VantOrtomosaicoFlow"
    >
      <Spin
        tip="Carregando..."
        spinning={loading}
        className="VantOrtomosaicoFlow__Spin"
      >
        <Row
          className="VantOrtomosaicoFlow__MainRow"
        >
          <Col
            span={24}
            className="VantOrtomosaicoFlow__MainColumn"
          >
            <div
              style={{
                display: currentPage === 0 ? 'block' : 'none',
              }}
              className="VantOrtomosaicoFlow__SummaryConditionalRendererWrapper"
            >
              {
                currentPage === 0
                && (
                  <Summary
                    previousPage={previousPage}
                    nextPage={nextPage}
                    serviceRequestParameters={serviceRequestParameters}
                    removeSelectedField={removeSelectedField}
                  />
                )
              }
            </div>

            <div
              style={{
                display: currentPage === 1 ? 'block' : 'none',
              }}
              className="VantOrtomosaicoFlow__SuccessConditionalRendererWrapper"
            >
              <SuccessSolicitation
                previousPage={previousPage}
                params={serviceRequestParameters}
              />
            </div>
          </Col>
        </Row>
      </Spin>
    </div>
  );
};

Flow.propTypes = {};
Flow.defaultProps = {};

export default Flow;
